import http from '../http'
// 获取工作内容数据
export const getPatrolDeployListForApp = data => {
    return http(`/app-api/info/rule-permission/getPatrolDeployListForApp?projectId=${data.projectId}&module=patrol`, 'get', data)
}
// 获取设备数据
export const getPatrolEquTypeList = data => {
    return http(`/app-api/info/rule-permission/getPatrolEquTypeList?deployId=${data.deployId}`, 'get', data)
}

//工程名称等信息
export const get_project = data => {
    return http(`/app-api/app/inspection-prj/get-project?id=${data.id}`, 'get', data)
}

//巡检发布页选择人员
export const getMemberlist = data => {
    return http(`/app-api/info/rule-permission/getMemberUsers`, 'get', data, true)
}

//巡检列表页选择人员
export const getPatrolMemberUsers = data => {
    return http(`/app-api/info/rule-permission/getPatrolMemberUsers`, 'get', data, true)
}

//巡检列表页选择设备
export const getEquTypeListByInfo = data => {
    return http(`/app-api/info/rule-permission/getEquTypeListByInfo`, 'get', data, true)
}



//巡检列表检查人员上传
export const synMemupdate = data => {
    return http(`/app-api/patrol/info/update`, 'post', data)
}

//巡检选择设备列表数据
export const getSubInstallPos = data => {
    return http(`/app-api/patrol/info-sub/getSubInstallPos`, 'get', data, true)
}

//巡检设备列表数据
export const getSubInstalList = data => {
    return http(`/app-api/patrol/info-sub/getSubPosDetail`, 'get', data, true)
}

//只读巡检设备所有选中列表数据
export const getAllSubPosDetail = data => {
    return http(`/app-api/patrol/info-sub/getAllSubPosDetail`, 'get', data, true)
}

//只读所有动态信息tab栏渲染
export const getAllDevice = data => {
    return http(`/app-api/patrol/info-sub-device/getAllDevice`, 'get', data, true)
}

//动态信息tab栏渲染
export const getDevice = data => {
    return http(`/app-api/patrol/info-sub-device/getDevice`, 'get', data, true)
}



//动态信息列表输入框渲染
export const getsetactive = data => {
    return http(`/app-api/patrol/info-active/get-set-active`, 'get', data, true)
}

//只读页面结论建议所有人数据
export const getSubByInfoId = data => {
    return http(`/app-api/patrol/info-sub/getSubByInfoId`, 'get', data, true)
}



//动态信息上传
export const updatebatch = data => {
    return http("/app-api/patrol/info-active/update", 'post', data)
}


//巡检内容基本检查项数据
export const getsetproblem = data => {
    return http("/app-api/patrol/info-problem/get-set-problem", 'get', data, true)
}



//巡检内容上传数据
export const maintenanceUpdateInfoProblemList = data => {
    return http("/app-api/patrol/info-problem/update-batch", 'post', data)
}

//其它检查项获取数据
export const getotheritem = data => {
    return http("/app-api/patrol/info-problem/get-other-item", 'get', data, true)
}

//其它检查项添加问题
export const getsetotheritem = data => {
    return http("/app-api/patrol/info-problem/get-set-other-item", 'get', data, true)
}

//巡检tab栏完成查询
export const checkSubDetail = data => {
    return http("/app-api/patrol/info-sub/checkSubDetail", 'get', data, true)
}

//问题描述
export const getproblemdescription = data => {
    return http("/app-api/patrol/info-problem/get-problem-description", 'get', data, true)
}
//风险备注
export const getriskremark = data => {
    return http("/app-api/patrol/info-problem/get-risk-remark", 'get', data, true)
}

//备注建议
export const getnote = data => {
    return http("/app-api/patrol/info-problem/get-note", 'get', data, true)
}



//派发
export const distributeUpData = data => {
    return http(`/app-api/patrol/info/create`, 'post', data)
}

//修改
export const changeUpData = data => {
    return http(`/app-api/patrol/info/update`, 'post', data)
}

//工程概况数据
export const getSubBySubId = data => {
    return http(`/app-api/patrol/info-sub/getSubBySubId?subId=${data.subId}`, 'get', data)
}

//巡检完成
export const checkSubData = data => {
    return http(`/app-api/patrol/info-sub/checkSubData`, 'get', data, true)
}

//结论建议 获取结论建议列表
export const getNotifyNoteByInfoId = data => {
    return http(`/app-api/patrol/info/getNotifyNoteByInfoId?infoId=${data.infoId}`, 'get', data)
}
//结论建议页面 上传
export const notifyNoteUpdate = data => {
    return http(`/app-api/patrol/info-sub/update`, 'post', data)
}
//结论建议页面 获取
export const getsubsignface = data => {
    return http(`/app-api/patrol/info-sub/get-sub-sign-face?id=${data.id}`, 'get', data)
}

//获取待处理
export const getListByStatus = data => {
    return http(`/app-api/patrol/info-sub/getListByStatus`, 'get', data, true)
}
//删除待处理
export const deletePatrolInfo = data => {
    return http(`/app-api/patrol/info/delete?infoId=${data.infoId}`, 'delete', data)
}


//获取我发布
export const getIaunchPageList = data => {
    return http(`/app-api/patrol/info-sub/getListByInfoMe`, 'get', data, true)
}
//获取我参与

export const getListByMe = data => {
    return http(`/app-api/patrol/info-sub/getListByMe`, 'get', data, true)
}

export const getListByManage = data => {
    return http(`/app-api/patrol/info-sub/getListByManage`, 'get', data, true)
}

export const getPageByManage = data => {
    return http(`/app-api/patrol/info-sub/getPageByManage`, 'get', data, true)
}

//获取人员操作详情
export const getListByInfoId = data => {
    return http(`/app-api/patrol/info-sub/getListByInfoId?infoId=${data.infoId}`, 'get', data)
}

//根据人员操作记录查看详情

export const getOneBySubId = data => {
    return http(`/app-api/patrol/info-sub/getOneBySubId?subId=${data.subId}`, 'get', data)
}

//人员操作详情最终完成
export const updatecomplete = data => {
    return http(`/app-api/patrol/info/update-complete`, 'get', data, true)
}

// 结论建议 选择停机设备时上传
export const shutdownDevice = data => {
    return http(`/app-api/patrol/info-sub-device/shutdown-device`, 'post', data)
}


// 只读页 拿所有人员结论建议

export const getSubAllResult = data => {
    return http(`/app-api/patrol/info-sub/get-all-sub-result?infoId=${data.infoId}`, 'get', data)
}

// 获取生成文档列表

export const getReportById = data => {
    return http(`/admin-api/patrol/deploy-report/getReportById?infoId=${data.infoId}`, 'get', data)
}

// 获取子单数据源
export const getSubDoneByInfoId = data => {
    return http(`/app-api/patrol/info-sub/getSubDoneByInfoId?infoId=${data.infoId}`, 'get', data)
}

// 生成文档

export const insertExportBatchByInfoId = data => {
    return http(`/admin-api/patrol/deploy-report/insertExportBatchByInfoId`, 'post', data)
}


export const update = data => {
    return http(`/app-api/patrol/info-sub/update`, 'post', data)
}

// 获取下载列表
export const getExportReportListByInfoId = data => {
    return http(`/app-api/patrol/export-report/getExportReportListByInfoId?infoId=${data.infoId}`, 'get', data)
}

// 停机设备汇总列表
export const getShutDownDevice = data => {
    return http(`/app-api/patrol/info-sub-device/getShutDownDevice?infoId=${data.infoId}`, 'get', data)
}
// // 结论建议汇总列表
// export const getSubByInfoId = data => {
//     return http(`/app-api/patrol/info-sub/getSubByInfoId?infoId=${data.infoId}`, 'get', data)
// }
// 闭单
export const complete = data => {
    return http(`/app-api/patrol/info/complete`, 'post', data)
}

//其他文件 新增

export const otherDocumentsCreate = data => {
    return http(`/app-api/patrol/info-other-documents/create`, 'post', data)
}

// 其他文件 修改

export const otherDocumentsUpdate = data => {
    return http(`/app-api/patrol/info-other-documents/update`, 'post', data)
}
// 其他文件 获取
export const otherDocumentsGetList = data => {
    return http(`/app-api/patrol/info-other-documents/getList?patrolInfoId=${data.patrolInfoId}`, 'get', data)
}

// 其他文件 获取
export const otherDocumentsGet = data => {
    return http(`/app-api/patrol/info-other-documents/get?id=${data.id}`, 'get', data)
}

// 其他文件 删除
export const otherDocumentsDelete = data => {
    return http(`/app-api/patrol/info-other-documents/delete?id=${data.id}`, 'delete', data)
}

//删除其它问题
export const deleteissueapi = data => {
    return http(`/app-api/patrol/info-problem/delete?problemId=${data.problemId}`, 'delete', data)
}
// 闭单撤回
export const patrolRevocation = data => {
    return http(`/app-api/patrol/info/revocation`, 'put', data, true)
}


//结论建议新增建议
export const createinfonote = data => {
    return http(`/app-api/patrol/info-note/create?SubId=${data.SubId}`, 'post', data)
}


//新增建议列表获取
export const infonotegetList = data => {
    return http(`/app-api/patrol/info-note/getList`, 'get', data, true)
}


//结论建议删除
export const deleteinfonote = data => {
    return http(`/app-api/patrol/info-note/delete?id=${data.id}`, 'delete', data)
}


//结论建议新增建议
export const infonoteupdate = data => {
    return http(`/app-api/patrol/info-note/update`, 'post', data)
}



//闭单获取结论汇总
export const getAllNoteByInfoId = data => {
    return http(`/app-api/patrol/info-sub/getAllNoteByInfoId`, 'get', data, true)
}


// 获取对比单号列表
export const getPatrolContrastList = data => {
    return http(`/app-api/patrol/info/getPatrolContrastList`, 'get', data, true)
}


//更新对比单号
export const updateContrast = data => {
    return http(`/app-api/patrol/info/update-contrast?infoId=${data.infoId}&&contrastId=${data.contrastId}`, 'post', data)
}

//合并-获取subInfo 完成 情况
export const getSubInfoDoneResult = data => {
    return http(`/app-api/patrol/info-merge/check`, 'get', data, true)
}

///合并-获取合并后的设备数据
export const getMergeDevice = data => {
    return http(`/app-api/patrol/info-merge/getMergeDevice`, 'get', data, true)
}

///合并-获取合并后的设备数据
export const getMergeAllDevice = data => {
    return http(`/app-api/patrol/info-merge/getMergeAllDevice`, 'get', data, true)
}

//合并-审核基本检查项数据
export const getMergeProblem = data => {
    return http("/app-api/patrol/info-merge/get-merge-problem", 'get', data, true)
}
//合并-设备 类型 列表
export const getEquTypeMergeList = data => {
    return http(`/app-api/patrol/info-merge/list-type-equ`, 'get', data, true)
}
//合并-审核人员 列表
export const getAuditMembers = data => {
    return http(`/app-api/patrol/info-merge/list-member`, 'get', data, true)
}
//合并-分页列表
export const getMergeList = data => {
    return http(`/app-api/patrol/info-merge/page?pageNo=${data.pageNo}&pageSize=${data.pageSize}&infoId=${data.infoId}`, 'get', data)
}
//创建-合并info
export const createMergeInfo = data => {
    return http(`/app-api/patrol/info-merge/create`, 'post', data)
}
//删除-合并
export const deleteMergeInfo = data => {
    return http(`/app-api/patrol/info-merge/delete?id=${data.id}`, 'delete', data)
}
//合并-获取subInfo 完成 情况
export const getMergeStatus = data => {
    return http(`/app-api/patrol/info-merge/check-merge-status`, 'get', data, true)
}

//合并-批量更新基础数据
export const updateInfoMergeProblemList = data => {
    return http("/app-api/patrol/info-merge/problem-update-batch", 'post', data)
}

//合并-其它检查项添加问题
export const createMergeOtherItem = data => {
    return http("/app-api/patrol/info-merge/create-merge-other-item", 'get', data, true)
}

//合并-其它检查项获取数据
export const getMergeOtherItem = data => {
    return http("/app-api/patrol/info-merge/get-other-item", 'get', data, true)
}

//删除其它问题
export const deleteMergeProblem = data => {
    return http(`/app-api/patrol/info-merge/problem-delete?problemId=${data.problemId}`, 'delete', data)
}

//合并审核-tab栏完成查询
export const checkMergeDetail = data => {
    return http("/app-api/patrol/info-merge/checkMergeDetail", 'get', data, true)
}

//合并审核-tab栏完成查询
export const accomplish = data => {
    return http("/app-api/patrol/info-merge/accomplish", 'get', data, true)
}

//问题描述
export const getmergeproblemdescription = data => {
    return http("/app-api/patrol/info-merge/get-problem-description", 'get', data, true)
}
//风险备注
export const getmergeriskremark = data => {
    return http("/app-api/patrol/info-merge/get-risk-remark", 'get', data, true)
}

//备注建议
export const getmergenote = data => {
    return http("/app-api/patrol/info-merge/get-note", 'get', data, true)
}


//工程概况数据
export const getProjectByMergeId = data => {
    return http(`/app-api/patrol/info-merge/getProjectByMergeId?infoMergeId=${data.infoMergeId}`, 'get', data)
}

//巡检设备列表数据
export const getMergePosDetail = data => {
    return http(`/app-api/patrol/info-merge/getMergePosDetail`, 'get', data, true)
}

//只读巡检设备所有选中列表数据
export const getAllMergePosDetail = data => {
    return http(`/app-api/patrol/info-merge/getAllMergePosDetail`, 'get', data, true)
}
